import React from 'react'
import Footer from '../components/footerComponent/footer'
import Signin from '../components/signinComponent/signin'
import {Layout} from 'antd';

export default function AuthPage() {
    return (
        <Layout>
            <Signin/>
            <Footer/>
        </Layout>
    );
};
